import React, { useMemo, useState } from "react";
import "../../common.scss";
import { useQuery } from "@tanstack/react-query";
import { Trans } from "react-i18next";
import { Select, Tooltip, DatePicker, Space } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useTranslation } from "react-i18next";
import ApplicationListTable from "./applicationListTable";
import {
  getApplications,
  getSchemaForApplications,
} from "../../utility/commonApi";
import { useSelector } from "react-redux";
const { Option } = Select;
const { RangePicker } = DatePicker;
dayjs.extend(utc);
dayjs.extend(timezone);
function MyApplications() {
  const { t } = useTranslation();
  const trustId = localStorage.getItem("trustId");
  const userDetails = useSelector((state) => state.auth);
  const user = userDetails ? userDetails.user : null;
  const { data: schema } = useQuery({
    queryKey: ["schema", trustId],
    queryFn: () => getSchemaForApplications({ trustId }),
    keepPreviousData: true,
  });

  const schemas = useMemo(() => schema?.schemas ?? [], [schema]);
  const [status, setStatus] = useState("");
  const [caseType, setCaseType] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState({
    fromDate: dayjs().startOf("month").toISOString(),
    toDate: dayjs().endOf("month").toISOString(),
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  const { data, isLoading } = useQuery({
    queryKey: [
      "MyApplications",
      trustId,
      pagination.page,
      pagination.limit,
      status,
      caseType,
      dateRangeFilter,
      user,
    ],
    queryFn: () =>
      getApplications({
        ...pagination,
        trustId: trustId,
        status,
        caseType,
        fromDate: dateRangeFilter.fromDate,
        toDate: dateRangeFilter.toDate,
        loggedinUserId: user?._id,
      }),
    keepPreviousData: true,
  });
  // console.log(data);
  const statusOptions = [
    { value: "submitted", label: "Submitted" },
    { value: "completed", label: "Completed" },
    { value: "rejected", label: "Rejected" },
    { value: "inProgress", label: "In Progress" },
    { value: "approved", label: "Approved" },
    // { value: "new", label: "New" },
    // { value: "needMoreInfo", label: "Need More Info" },
  ];
  const caseTypes = Array.isArray(schemas)
    ? schemas.map((schema) => ({
        value: schema.key || "",
        label: schema.title || "Untitled Form",
      }))
    : [];

  return (
    <div className="listviewwrapper">
      <div className="d-flex align-items-center justify-content-between mb-1">
        <div className="addAction">
          <span className="commonFont">Applications</span>
        </div>
        <div>
          <Space wrap className="">
            <div style={{ width: "100%" }}>
              <RangePicker
                id="dateRangePickerANTD"
                format="DD MMM YYYY"
                value={
                  dateRangeFilter
                    ? [
                        dayjs(dateRangeFilter.fromDate),
                        dayjs(dateRangeFilter.toDate),
                      ]
                    : null
                }
                placeholder={[t("Start Date"), t("End Date")]}
                onChange={(dates) => {
                  if (dates && dates.length === 2) {
                    const [start, end] = dates;
                    setDateRangeFilter({
                      fromDate: start.startOf("day").toISOString(),
                      toDate: end.endOf("day").toISOString(),
                    });
                  } else {
                    // Reset to current month if cleared
                    setDateRangeFilter(null);
                  }
                }}
                style={{ width: "100%" }}
              />
            </div>
            <div className="d-flex flex-row gap-1" id="accountsListDrop">
              {/* Status Filter */}
              <Select
                placeholder="Select Status"
                style={{ width: "150px", height: "45px" }}
                onChange={(value) => {
                  setStatus(value);
                }}
                allowClear
              >
                {statusOptions.map(({ value, label }) => (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                ))}
              </Select>

              {/* Case Type Filter */}
              <Select
                placeholder="Select Case Type"
                style={{ width: "180px", height: "45px" }}
                onChange={(value) => {
                  setCaseType(value);
                }}
                allowClear
              >
                {caseTypes.map((item) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </div>
          </Space>
        </div>
      </div>
      <ApplicationListTable
        data={data ? data?.data?.results : []}
        totalItems={data ? data?.data?.totalResults : 0}
        pageSize={pagination.limit}
        onChangePage={(page) => {
          setPagination((prev) => ({ ...prev, page }));
        }}
        onChangePageSize={(pageSize) => {
          setPagination((prev) => ({
            ...prev,
            limit: pageSize,
            page: 1,
          }));
        }}
      />
    </div>
  );
}

export default MyApplications;
